//dependencias
import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import { googleLogout } from '@react-oauth/google';

//estilos
import "./SideBarAction.css";
import Alert from "../../modal/alert";
//import Chat from "../Chat";
//componentes
import { outCliente1, outToken } from "../../accion/accion";
import { saveCliente, saveToken } from "../../accion/accion";

class SideBarAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      acordion1: false,
      acordion2: false,
      acordion3: false,
      acordion4: false,
      acordion5: false,
      opcionMenu: "",
      menuOn: false,
      mensajealerta: false,
      sacordion1: false,
      sacordion2: false,
      sacordion3: false,
      sacordion4: false,
      sacordion5: false,
      sopcionMenu: "",
      smenuOn: false,
      ssacordion1: false,
      ssacordion2: false,
      ssacordion3: false,
      ssacordion4: false,
      ssacordion5: false,
      ssopcionMenu: "",
      ssmenuOn: false,
      igradosC: [],
      grado:'',
      tipoCon:'',
      trimestre:'',
    };
    this.verificar = this.verificar.bind(this);
  }
  verificar(e, value) {
    //  console.log([e.target.checked])
    //  console.log(value)
    //  console.log(e.target.name)
    if (e.target.checked === true) {
      this.setState({ [e.target.getAttribute("id")]: true });
      if (e.target.name==='grado'){
        this.setState({ grado: value });
            let username = this.props.usuario1.usuario;
            let clav = "";
            let nivel = value;
            let anioE = "";
            let cedulaU = "";
            this.props.saveCliente(username, clav, nivel, anioE, cedulaU);
      }
      if (e.target.name==='tipoC'){
            this.setState({ tipoCon: value });
            let username = this.props.usuario1.usuario;
            let clav = "";
            let nivel = this.state.grado;
            let anioE = value;
            let cedulaU = "";
            this.props.saveCliente(username, clav, nivel, anioE, cedulaU);
      }
      
    } else {
      this.setState({ [e.target.getAttribute("id")]: false });
      if (e.target.name==='grado'){
        this.setState({ grado:''});
      }
      if (e.target.name==='tipoC'){
        this.setState({ tipoCon:''});
      }
    }

  }

  cerrarsesion() {
    let username = "";
    let clav = "";
    let nivel = "";
    let anioE = "";
    let cedulaU = "";
    this.props.saveCliente(username, clav, nivel, anioE, cedulaU);
    // googleLogout();
    // this.setState({
    //   mensajealerta: true,
    //   tituloM: "Menu Curricular",
    //   cuerpoM: "Recuerde Cerrar su Sesion de Google Gracias...",
    // });

  }
  opmenu1 = () => {
    this.setState({ opcionMenu: "1", menuOn: true });
  };
  opmenu2 = () => {
    this.setState({ opcionMenu: "2", menuOn: true });
  };

  cerrarMenu = () => {
    this.setState({ opcionMenu: "", menuOn: false });
  };

  prueba() {
    // return <Redirect to="/medicamento" />;
  }

  consultarGrado = () => {
    let data = new FormData();
    data.append("usuario", this.props.usuario1.usuario);
    data.append("boton", "consultaGrado");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/backend/curriculum.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        if (res.data.variable1) {
          console.log("paso bien " + this.props.usuario1.usuario);
          this.setState({
            igradosC: res.data.variable2,
          });
        }
      });
  };
  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  componentDidMount() {
    this.consultarGrado();
  }

  render() {
    //console.log('nivel - '+this.props.usuario1.nivel);
    //console.log('usuario: '+this.props.usuario1.usuario);
    if (this.props.usuario1.usuario === "") {
      // window.location.reload();
      return <Redirect to="/login" />;
    }
    return (
      <div>
        {this.state.mensajealerta === true && (
          <Alert
            tituloMensaje={this.state.tituloM}
            cuerpoMensaje={this.state.cuerpoM}
            open={this.state.mensajealerta}
            handleClose={this.handleClose}
          />
        )}
        <div className="contenedor-menus">
          <li className="item">
            <Link to="#" className="btn-menu">
              Menu <i className="icono fas fa-bars"></i>
            </Link>
          </li>
          <div className="menu">
            <ul>
              <span className="btn1">Menu Principal</span>

              <li className="item">
                <label className="btn" htmlFor="acordion1">
                  <i className="icono izquierda fas fa-file-medical" />
                  GRADOS
                  {this.state.acordion1 === true ? (
                    <i className="icono-derecha-up fas fa-chevron-up" />
                  ) : (
                    <i className="icono derecha fas fa-chevron-down" />
                  )}
                </label>
                <input
                  type="checkbox"
                  id="acordion1"
                  checked={this.state.acordion1}
                  onChange={this.verificar}
                />

                {this.state.igradosC.map((item, i) => {
                  return (
                    <div className="smenu" id="informe">
                      <ul>
                        <li className="item">
                          <label
                            className="btn"
                            htmlFor={
                              i === 0
                                ? "sacordion1"
                                : i === 1
                                ? "sacordion2"
                                : i === 2
                                ? "sacordion3"
                                : i === 3
                                ? "sacordion4"
                                : i === 4
                                ? "sacordion5"
                                : i === 5
                                ? "sacordion6"
                                : ""
                            }
                          >
                            <i className="icono izquierda fas fa-file-medical" />
                            {item.variable2}

                            {this.state.sacordioni === true ? (
                              <i className="icono-derecha-up fas fa-chevron-up" />
                            ) : (
                              <i className="icono derecha fas fa-chevron-down" />
                            )}
                          </label>
                          <input
                            type="checkbox"
                            name="grado"
                            id={
                              i === 0
                                ? "sacordion1"
                                : i === 1
                                ? "sacordion2"
                                : i === 2
                                ? "sacordion3"
                                : i === 3
                                ? "sacordion4"
                                : i === 4
                                ? "sacordion5"
                                : i === 5
                                ? "sacordion6"
                                : ""
                            }
                            checked={
                              i === 0
                                ? this.state.sacordion1
                                : i === 1
                                ? this.state.sacordion2
                                : i === 2
                                ? this.state.sacordion3
                                : i === 3
                                ? this.state.sacordion4
                                : i === 4
                                ? this.state.sacordion5
                                : i === 5
                                ? this.state.sacordion6
                                : ""
                            }
                            onChange={(e)=>this.verificar(e,item.variable1)}
                          />
                          {item.variable3.search("1") >= 0 &&  (
                            <div className="ssmenu" id="informe">
                              <ul>
                                <li className="item">
                                  <label className="btn" htmlFor="ssacordion1">
                                    <i className="icono izquierda fas fa-file-medical" />

                                    <span className="submenu">
                                      Coordinacion
                                    </span>
                                    {this.state.ssacordion1 === true ? (
                                      <i className="icono-derecha-up fas fa-chevron-up" />
                                    ) : (
                                      <i className="icono derecha fas fa-chevron-down" />
                                    )}
                                  </label>
                                  <input
                                    type="checkbox"
                                    id="ssacordion1"
                                    name="tipoC"
                                    checked={this.state.ssacordion1}
                                    onChange={(e)=>this.verificar(e,1)}
                                  />

                                  <div className="sssmenu" id="informe">
                                    <ul>
                                      {item.variable4.search("1") >= 0 && (
                                        <li>
                                          
                                         <Link to="/primerT">1er. Trimestre</Link>
                                        </li>
                                      )}
                                      {item.variable4.search("2") >= 0 && (
                                        <li>
                                          <Link to="/segundoT">2do. Trimestre</Link>
                                        </li>
                                      )}
                                      {item.variable4.search("3") >= 0 && (
                                        <li>
                                          <Link to="/tercerT">3er. Trimestre</Link>
                                        </li>
                                      )}
                                    </ul>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          )}
                          {item.variable3.search("2") >= 0 && (
                            <div className="ssmenu" id="informe">
                              <ul>
                                <li className="item">
                                  <label className="btn" htmlFor="ssacordion2">
                                    <i className="icono izquierda fas fa-file-medical" />

                                    <span className="submenu">Docente</span>
                                    {this.state.ssacordion2 === true ? (
                                      <i className="icono-derecha-up fas fa-chevron-up" />
                                    ) : (
                                      <i className="icono derecha fas fa-chevron-down" />
                                    )}
                                  </label>
                                  <input
                                    type="checkbox"
                                    id="ssacordion2"
                                    name="tipoC"
                                    checked={this.state.ssacordion2}
                                    onChange={(e)=>this.verificar(e,2)}
                                  />

                                  <div className="sssmenu" id="informe">
                                    <ul>
                                      {item.variable4.search("1") >= 0 && (
                                        <li>
                                          <Link to="/primerT">1er. Trimestre</Link>
                                        </li>
                                      )}
                                      {item.variable4.search("2") >= 0 && (
                                        <li>
                                          <Link to="/segundoT">2do. Trimestre</Link>
                                        </li>
                                      )}
                                      {item.variable4.search("3") >= 0 && (
                                        <li>
                                          <Link to="/tercerT">3er. Trimestre</Link>
                                        </li>
                                      )}
                                    </ul>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          )}
                          {item.variable3.search("3") >= 0 && (
                            <div className="ssmenu" id="informe">
                              <ul>
                                <li className="item">
                                  <label className="btn" htmlFor="ssacordion3">
                                    <i className="icono izquierda fas fa-file-medical" />
                                    <span className="submenu">Alumnos</span>
                                    {this.state.ssacordion3 === true ? (
                                      <i className="icono-derecha-up fas fa-chevron-up" />
                                    ) : (
                                      <i className="icono derecha fas fa-chevron-down" />
                                    )}
                                  </label>
                                  <input
                                    type="checkbox"
                                    id="ssacordion3"
                                    name="tipoC"
                                    checked={this.state.ssacordion3}
                                    onChange={(e)=>this.verificar(e,3)}
                                  />

                                  <div className="sssmenu" id="informe">
                                    <ul>
                                      {item.variable4.search("1") >= 0 && (
                                        <li>
                                          <Link to="/primerT">1er. Trimestre</Link>
                                        </li>
                                      )}
                                      {item.variable4.search("2") >= 0 && (
                                        <li>
                                          <Link to="/segundoT">2do. Trimestre</Link>
                                        </li>
                                      )}
                                      {item.variable4.search("3") >= 0 && (
                                        <li>
                                          <Link to="/tercerT">3er. Trimestre</Link>
                                        </li>
                                      )}
                                    </ul>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          )}
                        </li>
                      </ul>
                    </div>
                  );
                })}
              </li>

              {this.props.usuario1.usuario === "STEFICOORDINACION@GMAIL.COM" ||
              this.props.usuario1.usuario === "HPPEROG@GMAIL.COM" ? (
                <li className="item">
                  <label className="btn" htmlFor="acordion2">
                    <i className="icono izquierda fas fa-file-medical" />
                    ADMINISTRADOR
                    {this.state.acordion2 === true ? (
                      <i className="icono-derecha-up fas fa-chevron-up" />
                    ) : (
                      <i className="icono derecha fas fa-chevron-down" />
                    )}
                  </label>
                  <input
                    type="checkbox"
                    id="acordion2"
                    checked={this.state.acordion2}
                    onChange={this.verificar}
                  />

                  <div className="smenu" id="informe">
                    <ul>
                      <li>
                        <Link to="/grados">Crear Grados</Link>
                      </li>
                      <li>
                        <Link to="/permiso">Asignar Permisos a Usuarios</Link>
                      </li>
                      <li>
                        <Link to="/subirCurri">Subir Archivos</Link>
                      </li>
                    </ul>
                  </div>
                </li>
              ) : (
                ""
              )}

              <li className="item">
                <Link
                  to="/"
                  className="btn"
                  onClick={this.cerrarsesion.bind(this)}
                >
                  <i className="icono izquierda fas fa-sign-out-alt"></i>
                  Cerrar Sesión Sistema
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};

const mapDispatchToProps = {
  outCliente1,
  outToken,
  saveCliente,
  saveToken,
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBarAction);
